import { useEffect } from "react";
import moment from "moment";

export const TEACHER_CALENDAR_CULTURE = "en";

export const teacherCalendarMessages = {
  date: "Date",
  time: "Time",
  event: "Event",
  allDay: "All Day",
  week: "Week",
  work_week: "Work Week",
  day: "Day",
  month: "Month",
  previous: "Back",
  next: "Next",
  yesterday: "Yesterday",
  tomorrow: "Tomorrow",
  today: "Today",
  agenda: "Agenda",
  noEventsInRange: "There are no events in this range.",
  showMore: (total) => `+${total} more`,
};

export function useTeacherCalendarLocale() {
  useEffect(() => {
    moment.locale(TEACHER_CALENDAR_CULTURE);
  }, []);
}
